import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { getAuthorIdFromSearchValue } from '@@components/AuthorSearchableAutocomplete/utils';
import { type ContentLanguage } from '@@lib/i18n/constants';

import { type TeasersSearchParams } from './teasersSearchParams';

export const TEASERS_PAGE_SIZE = 30;

/** The request's parameters, which live updates also match their events against */
export const teasersParams = (search: TeasersSearchParams) => ({
    size: TEASERS_PAGE_SIZE,
    q: search.q,
    tenantIds: search.tenantIds,
    userIds: getAuthorIdFromSearchValue(search.userIds),
    contentType: search.contentType,
    publishedOrReady: true,
    tagIds: search.tagIds,
    categoryIds: search.categoryIds,
    sort: 'updatedAt,desc',
});

export const teasersQuery = (search: TeasersSearchParams, contentLocale: ContentLanguage) =>
    client.metadata.metadata.getAll.infiniteQueryOptions(
        {
            query: teasersParams(search),
            headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
        },
        { refetchOnWindowFocus: false },
    );
